export default "https://cdn.questicon.mathletics.com/assets/images/Star-5c1ea9c9606fc6d94347ed074366ee18.svg";